<template>
  <el-row class="dormitory-log-main">
    <el-tabs v-model="activeName"
             type="card"
             @tab-click="handleClick">
      <el-tab-pane label="已启用"
                   name="old"></el-tab-pane>
      <el-tab-pane label="未启用"
                   name="new"></el-tab-pane>
    </el-tabs>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="网关名称:"
                      prop="name">
          <el-input v-model.trim="searchForm.name"
                    placeholder="网关名称"></el-input>
        </el-form-item>
        <el-form-item label="所属区域:"
                      prop="area_id">
          <el-select v-model="searchForm.area_id"
                     placeholder="请选择所属区域">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 在线状态 1在线 0不在线 -->
        <el-form-item label="在线状态:"
                      prop="online">
          <el-select v-model="searchForm.online"
                     placeholder="在线状态">
            <el-option label="全部"
                       value=""></el-option>
            <el-option label="在线"
                       value="1"></el-option>
            <el-option label="离线"
                       value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <!-- <el-button type="primary"
                 @click="handleConfirm('manForm')">
        确 定
      </el-button> -->
      <!-- <el-button type="primary"
                 @click="multipleAct">批量注销</el-button> -->
    </el-row>
    <el-card shadow="none">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="60"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'online'">
              <el-tag v-if="scope.row[item.prop] === '0'"
                      type="danger"> off </el-tag>
              <el-tag v-else
                      type="success"> on </el-tag>
            </template>
            <template v-else-if="item.prop === 'activated'">
              <el-tag v-if="scope.row[item.prop] === '1'"
                      type="success"> 已激活 </el-tag>
              <el-tag v-else
                      type="danger"> 未激活 </el-tag>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         :width="150">
          <template slot-scope="scope">
            <el-button v-has="'/gate/info'"
                       plain
                       v-if="activeName === 'old'"
                       size="mini"
                       type="primary"
                       @click="handleDetail(scope.row)">详情</el-button>
            <el-popover v-has="'/lock/edit'"
                        placement="bottom"
                        trigger="click">
              <el-button v-has="'/gate/edit'"
                         size="mini"
                         type="text"
                         @click="handleEdit(scope.row)">编辑</el-button>
              <el-button v-has="'/gate/getLora'"
                         size="mini"
                         type="text"
                         @click="handleSet(scope.row)">配置</el-button>
              <el-button v-has="'/gate/replace'"
                         v-if="activeName === 'old'"
                         size="mini"
                         type="text"
                         @click="handleChange(scope.row)">更换</el-button>
              <!-- <el-button v-if="scope.row.activated === '1'"
                       size="mini"
                       type="text"
                       @click="handleDelete(scope.row)">注销</el-button> -->
              <el-button slot="reference"
                         plain
                         size="mini"
                         type="primary"
                         style="margin-left: 10px;">更多</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <gateway-detail v-if="showDetailModal"
                    :isShow="showDetailModal"
                    :data="detailID"
                    @handleClose="closeDetailModal"></gateway-detail>
    <edit-gate v-if="showEditModal"
               :isShow="showEditModal"
               :data="editData"
               @handleClose="closeEdit"></edit-gate>
    <gate-config v-if="showSetModal"
                 :isShow="showSetModal"
                 :data="setData"
                 @handleClose="closeSet"></gate-config>
    <change-gate v-if="showChangeModal"
                 :isShow="showChangeModal"
                 :data="changeData"
                 @handleClose="closeChange"></change-gate>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import EditGate from '@/views/device/gateway/EditGate'
import GatewayDetail from '@/views/device/gateway/GatewayDetail'
import GateConfig from '@/views/device/gateway/GateConfig'
import ChangeGate from '@/views/device/gateway/ChangeGate'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { GatewayDetail, Pagination, EditGate, GateConfig, ChangeGate },
  data() {
    return {
      activeName: 'old',
      areaList: [],
      searchForm: {
        name: '',
        area_id: '',
        online: ''
      },
      tableTitle: [
        {
          prop: 'name',
          name: '名称',
          width: '230'
        },
        {
          prop: 'clientid',
          name: 'ClientID',
          width: '240'
        },
        {
          prop: 'area_names',
          name: '区域',
          width: '250'
        },
        {
          prop: 'lock_count',
          name: '设备数量',
          width: '80'
        },
        {
          prop: 'online',
          name: '在线状态',
          width: '80'
        },
        {
          prop: 'sn',
          name: 'SN',
          width: '230'
        },
        // {
        //   prop: 'activated',
        //   name: '激活状态',
        //   width: '80'
        // },
        {
          prop: 'regtime',
          name: '激活时间',
          width: '160'
        },
        {
          prop: 'remarks',
          name: '备注',
          width: '150'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 详情相关
      showDetailModal: false,
      detailID: -1,
      // 定义进度条颜色
      customColors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#67c23a', percentage: 100 }
      ],
      // 编辑弹窗
      showEditModal: false,
      editData: {},
      // lora
      showSetModal: false,
      setData: {},
      // 更换
      showChangeModal: false,
      changeData: {},
      tmpArr: []
    }
  },
  created() {
    this.getList()
    this.getAreaTree()
  },
  methods: {
    // 造假数据用
    handleConfirm() {
      let i = 3
      let modal = {
        id: `${i}`,
        name: `网关123${i}`,
        ip: `192.1.1.${i}`,
        online: '0',
        activated: '1',
        area_id: `${i}`,
        lock_count: `2${i}`,
        sn: '12112',
        clientid: `${i}`,
        regtime: `2020-09-0${i} 10:10:09`,
        remarks: `这是备注${i}`
      }
      fetch.addGate({ ...modal }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.$message.success('操作成功')
            this.getList()
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getGateList({
          type: this.activeName,
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 获取数据
    getAreaTree() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    },
    handleClick() {
      this.getList()
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 批量注销
    multipleAct() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定注销选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.destroyGate(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择需要注销的设备后重试')
      }
    },
    // 更换
    handleChange(data) {
      this.showChangeModal = true
      this.changeData = {
        id: data.id
      }
    },
    closeChange() {
      this.showChangeModal = false
    },
    // 详情
    handleDetail(data) {
      this.showDetailModal = true
      this.detailID = data.id
    },
    closeDetailModal() {
      this.showDetailModal = false
    },
    // 编辑
    handleEdit(data) {
      this.showEditModal = true
      this.editData = {
        id: data.id
      }
    },
    closeEdit(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showEditModal = false
    },
    // 设置
    handleSet(data) {
      this.showSetModal = true
      this.setData = {
        id: data.id,
        sn: data.sn
      }
    },
    closeSet() {
      this.showSetModal = false
    },
    // 注销
    handleDelete(data) {
      this.$confirm('是否确定注销该设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.destroyGate(data.id)
        })
        .catch(() => {})
    },
    // 注销网关
    destroyGate(ids) {
      fetch.editGate({ id: ids, activated: '0' }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.$message.success('操作成功')
            this.getList()
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style lang="less">
.dormitory-log-main {
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: #fff;
    border-bottom-color: #409eff;
  }
}
</style>
